// @flow

import {debounce} from 'lodash';
import {ArrowDirection, ARROW_SCROLLING_TIME} from './constants';

import type {Delta, DeltaStatic, OnArrowScroll} from './typedef';
import type {ArrowDirectionType} from './constants';

type PreparedDelta = Array<number>;
type NavigationArrowsType = {|
    delta: Delta,
    onArrowScroll: OnArrowScroll,
    leftShift: number,
|};

export default class NavigationArrows {
    delta: ?PreparedDelta;
    deltaStatic: ?DeltaStatic;
    contentWidth: number;
    containerWidth: number;
    leftShift: number;
    onArrowScroll: OnArrowScroll;
    onAfterScroll: () => void;

    constructor({delta, onArrowScroll, leftShift = 0}: NavigationArrowsType) {
        this.onArrowScroll = onArrowScroll;
        this.contentWidth = 0;
        this.containerWidth = 0;
        this.leftShift = leftShift;
        this.onAfterScroll = debounce(() => onArrowScroll({
            isArrowScrolling: false,
            shift: -this.leftShift
        }), ARROW_SCROLLING_TIME);
        this._prepareDelta(delta);
    }

    setLeftShift(leftShift: number) {
        this.leftShift = Math.abs(leftShift);
    }

    setContentWidth(contentWidth: number) {
        this.contentWidth = contentWidth;
    }

    setContainerWidth(containerWidth: number) {
        this.containerWidth = containerWidth;
    }

    setDelta(delta: Delta) {
        this._prepareDelta(delta);
    }

    _prepareDelta(delta: Delta) {
        if (Array.isArray(delta)) {
            this.delta = delta.reduce((all, current, index) => {
                return all.concat(typeof all[index - 1] !== 'undefined' ? all[index - 1] + current : current);
            }, []);
            this.deltaStatic = null;
        } else {
            this.deltaStatic = delta;
            this.delta = null;
        }
    }

    _getVisibleItems() {
        const delta = this.delta;
        const deltaStatic = this.deltaStatic;

        let prev;
        let next;

        const viewportWidth = this.containerWidth;
        const rightBound = this.leftShift + viewportWidth;
        const leftBound = this.leftShift;

        if (delta) {
            const findIndex = (value: number, from?: boolean) => delta.findIndex(i => (from ? i >= value : i > value));

            const fromIndex = findIndex(leftBound, true);
            let toIndex = findIndex(rightBound);
            toIndex = toIndex === -1 ? delta.length - 1 : toIndex;

            prev = -delta[fromIndex - 1] || 0;
            next = viewportWidth - delta[toIndex];
        } else if (deltaStatic) {
            const {cellSize} = deltaStatic;
            const maxIndex = this.contentWidth / cellSize;

            const prevIndex = Math.ceil(leftBound / cellSize) - 1;
            const nextIndex = Math.floor(rightBound / cellSize) + 1;

            prev = prevIndex > 0 ? -prevIndex * cellSize : 0;
            next = nextIndex >= maxIndex ? viewportWidth - this.contentWidth : viewportWidth - nextIndex * cellSize;
        } else {
            prev = 0;
            next = 0;
        }

        return {prev, next};
    }

    clickArrow(type: ArrowDirectionType) {
        const {prev, next} = this._getVisibleItems();
        let shift;

        switch (type) {
            case ArrowDirection.LEFT: {
                shift = prev;
                break;
            }
            case ArrowDirection.RIGHT: {
                shift = next;
                break;
            }
            default:
                shift = 0;
        }
        this.onArrowScroll({shift, isArrowScrolling: true});
        this.onAfterScroll();
    }
}

            // @pb/generate-flow-typed Webpack Loader:
            // Duplicates all internal dependencies imports
            // to be sure all deps are parsed by this loader
            // cause Babel loader removes `import type ...`
            // and e.g. 'typedef.js' files are not included in dist
            
require("./typedef");

require("./constants");
